// Hamburger menu (spec D7): the open button shows the menu (display flex, then a 300 ms
// fade in); its close button fades it out, then hides it; a tap on one of its links hides
// it at once. The fade is the CSS transition of the state class below.

import { afterTransition, prefersReducedMotion } from "./transitions.js";

const SELECTORS = {
  menu: ".hamburger-menu",
  open: ".menu-button.open",
  close: ".menu-button.close",
  item: ".hamburger-menu-item",
};

const OPEN = "is-open";
const FADE_MS = 300;

const pending = new WeakMap();

function cancelPending(menu) {
  pending.get(menu)?.();
  pending.delete(menu);
}

function show(menu) {
  cancelPending(menu);
  menu.style.display = "flex";
  // Commit the display change first, so the opacity transition starts from 0.
  void menu.offsetWidth;
  menu.classList.add(OPEN);
}

function fadeOut(menu) {
  cancelPending(menu);
  menu.classList.remove(OPEN);
  if (prefersReducedMotion()) {
    hide(menu);
    return;
  }
  pending.set(menu, afterTransition(menu, "opacity", FADE_MS, () => hide(menu)));
}

function hide(menu) {
  cancelPending(menu);
  menu.classList.remove(OPEN);
  menu.style.display = "";
}

export function initMenu() {
  const menus = document.querySelectorAll(SELECTORS.menu);
  if (menus.length === 0) return;
  for (const button of document.querySelectorAll(SELECTORS.open)) {
    button.addEventListener("click", () => menus.forEach(show));
  }
  for (const [selector, close] of [
    [SELECTORS.close, fadeOut],
    [SELECTORS.item, hide],
  ]) {
    for (const element of document.querySelectorAll(selector)) {
      const menu = element.closest(SELECTORS.menu);
      if (menu) element.addEventListener("click", () => close(menu));
    }
  }
}
